import { Component, Input } from '@angular/core';
import { Observable } from 'rxjs';
import { AutomationErrorHandlerService } from '../../../../services';
import { map } from 'rxjs/operators';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { GalaxyAlertModule } from '@vendasta/galaxy/alert';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { GalaxyFormFieldModule } from '@vendasta/galaxy/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
import { MatSelectModule } from '@angular/material/select';
import { GalaxyInputModule } from '@vendasta/galaxy/input';
import { GalaxyWrapModule } from '@vendasta/galaxy/galaxy-wrap';
import { GalaxyCheckboxModule } from '@vendasta/galaxy/checkbox';
import { GalaxyPipesModule } from '@vendasta/galaxy/pipes';

@Component({
  selector: 'automata-task-error-disclaimer',
  templateUrl: './task-error-disclaimer.component.html',
  styleUrls: ['./task-error-disclaimer.component.scss'],
  imports: [
    CommonModule,
    TranslateModule,
    GalaxyAlertModule,
    MatButtonModule,
    MatCardModule,
    FormsModule,
    GalaxyFormFieldModule,
    ReactiveFormsModule,
    MatInputModule,
    MatIconModule,
    MatSelectModule,
    GalaxyInputModule,
    GalaxyWrapModule,
    GalaxyCheckboxModule,
    GalaxyPipesModule,
  ],
})
export class TaskErrorDisclaimerComponent {
  @Input() stepId: string;
  @Input() isTrigger: boolean;

  constructor(private readonly errorHandler: AutomationErrorHandlerService) {}

  hasError(): Observable<boolean> {
    return this.errorHandler.hasError(this.stepId);
  }

  getErrorMessage(): Observable<string> {
    return this.errorHandler.getError(this.stepId).pipe(map((err) => (err ? err.errorMessage : '')));
  }
}
